import React from "react"
import FieldContainer, {
  InlineContainer,
} from "components/Form/FormFields/FieldParts/FieldContainer"
import Label from "components/Form/FormFields/FieldParts/Label"
import InputFeedback from "components/Form/FormFields/FieldParts/InputFeedback"

const DateSelect = ({ id, label, months, days, ...props }) => (
  <FieldContainer>
    <InlineContainer {...props} inline>
      <Label htmlFor={id} {...props} inline>
        {label}
      </Label>

      <div>
        <select
          id={id + "_month"}
          value={props.values[id + "_month"]}
          onChange={props.onChange}
        >
          {months ? (
            months.map(month => (
              <option key={`${id}_month_${month.value}`} value={month.value}>
                {month.display}
              </option>
            ))
          ) : (
            [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month, index) => (
              <option key={`${id}_month_${index + 1}`} value={index + 1}>
                {month}
              </option>
            ))
          )}
        </select>

        {!props.noDate && (
          <select
            id={id + "_day"}
            value={props.values[id + "_day"]}
            onChange={props.onChange}
          >
            {days ? (
              days.map(day => (
                <option key={`${id}_day_${day}`} value={day}>
                  {day}
                </option>
              ))
            ) : (
              [...Array(31).keys()].map(x => ++x).map(day => (
                <option key={`${id}_day_${day}`} value={day}>
                  {day}
                </option>
              ))
            )}
          </select>
        )}

        <select
          id={id + "_year"}
          value={props.values[id + "_year"]}
          onChange={props.onChange}
        >
          {props.years ? (
            props.years.map(year => (
              <option key={`${id}_year_${year}`} value={year}>
                {year}
              </option>
            ))
          ) : (
            [...Array(2)].map((i, key) => {
              const year = new Date().getFullYear() + key
              return (
                <option key={`${id}_year_${year}`} value={year}>
                  {year}
                </option>
              )
            })
          )}
        </select>
      </div>
    </InlineContainer>
    <InputFeedback {...props} />
  </FieldContainer>
)

export default DateSelect



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/DateSelect/index.js